import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@inplayer-org/inplayer-ui';

interface Props {
  style: {
    [key: string]: number;
  };
  content: string;
}

const TooltipWrapper = styled.div`
  position: absolute;
`;

const CursorTooltip: React.FunctionComponent<Props> = ({ style, content }) => (
  <TooltipWrapper style={style}>
    <Tooltip content={content} />
  </TooltipWrapper>
);

export default CursorTooltip;
